import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * The old standalone /testimonials page was a placeholder. The real social
 * proof lives on the homepage as the Wall of Wins (auto-populated by
 * verified partner review_wins). We redirect all /testimonials traffic
 * there so real customer wins get all the eyeballs.
 */
export default function TestimonialsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Preserve query string (utm params etc) — just swap the pathname + hash.
    navigate("/#wall-of-wins" + window.location.search, { replace: true });
    // Nudge the browser to actually scroll to the anchor after render.
    const t = setTimeout(() => {
      const el = document.getElementById("wall-of-wins");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 200);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      data-testid="testimonials-redirect"
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0A1628",
        color: "#D4AF37",
        fontFamily: "'Bebas Neue', sans-serif",
        letterSpacing: 2,
        fontSize: 18,
        padding: 20,
        textAlign: "center",
      }}
    >
      TAKING YOU TO THE WALL OF WINS…
    </div>
  );
}
